// extracted by mini-css-extract-plugin
export default {"root":"Content__root--MkzdW"};